import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export const generateResume = async (jobDescription, jwtToken) => {
  try {
    console.log("jwttoken", jwtToken);
    const response = await api.post(
      "/resume/generate",
      { job_description: jobDescription },
      {
        headers: { Authorization: `Bearer ${jwtToken}` },
      }
    );
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

export const uploadDocument = async (user_id, file) => {
  try {
    console.log(user_id);
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("file", file);

    const response = await api.post("/resume/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      const data = await response;
      return response;
    } else {
      if (response.status === 400) {
        throw new Error("Bad request: " + response.statusText);
      } else if (response.status === 500) {
        throw new Error("Internal server error: " + response.statusText);
      } else {
        // Handle other status codes
        throw new Error("Failed to upload document: " + response.statusText);
      }
    }
  } catch (error) {
    console.error("Error uploading document:", error);
    throw new Error("Failed to upload document: " + error.message);
  }
};

// export const updateUserProfile = async (userId, updatedData) => {
//   try {
//     const response = await api.put(`/user/${userId}`, updatedData);
//     return response.data;
//   } catch (error) {
//     // Handle errors
//     console.error("Error updating user profile:", error);
//     throw error;
//   }
// };

export const generateResumePDF = async (resumeData, jwtToken) => {
  try {
    const response = await api.post("/resume/generate_pdf", resumeData, {
      headers: { Authorization: `Bearer ${jwtToken}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};

// Add this new function
export const getUserResumes = async (jwtToken) => {
  try {
    const response = await api.get("/resume/user_resumes", {
      headers: { Authorization: `Bearer ${jwtToken}` },
    });
    return response.data.resumes;
  } catch (error) {
    console.error("Error fetching user resumes:", error);
    throw error;
  }
};

export default api;
